import CookieHelper from "@/helpers/CookieHelper";

export var login = {
  data() {
    return {
      email: "",
      password: "",
      emailRules: [
        v => !!v || this.$t("rules.email_required"),
        v => /.+@.+\..+/.test(v) || this.$t("rules.email_not_valid")
      ],
      passwordRules: [v => !!v || this.$t("rules.password_required")],
      loading: false,
      facebookLoginLoading: false
    };
  },

  mounted() {
    this.loadFacebookSDK(document, "script", "facebook-jssdk");
    this.initFacebook();
  },
  methods: {
    async initFacebook() {
      window.fbAsyncInit = function() {
        window.FB.init({
          appId: process.env.VUE_APP_FACEBOOK_APP_ID, //You will need to change this
          cookie: true, // This is important, it's not enabled by default
          version: "v7.0"
        });
      };
    },
    async loadFacebookSDK(d, s, id) {
      //TODO: Load sdk everytime or download?
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },
    async facebookLogin() {
      this.facebookLoginLoading = true;
      //request token and permissions from facebook
      let token = await new Promise(resolve =>
        window.FB.login(resolve, { scope: "user_birthday,user_gender" })
      );
      if (!token.authResponse) {
        this.$store.commit("viewstate/notify", {
          text: "Er ging iets niet goed bij het inloggen met Facebook",
          color: "error"
        });
        this.facebookLoginLoading = false;
      } else {
        //get user data
        let user_data_promise = await new Promise(resolve =>
          window.FB.api(
            "me",
            {
              fields: ["first_name", "last_name", "email", "birthday", "gender"]
            },
            resolve
          )
        );
        this.$store.dispatch("user/facebookLogin", token).then(hasSucceeded => {
          //returns true if login succeeded and user existed
          //return false if either go wrong
          if (hasSucceeded) {
            localStorage.setItem("authorized", "true");
            this.$router.push({ name: this.$store.state.config.main_page });
            this.facebookLoginLoading = false;
          } else {
            if (user_data_promise) {
              this.$router.push({
                name: "registration",
                params: { user_data_promise }
              });
              this.facebookLoginLoading = false;
            } else {
              this.$store.commit("viewstate/notify", {
                text:
                  "Er ging iets fout bij het doorsturen naar de registratie pagina. Probeer het later opnieuw of registreer op een andere manier.",
                color: "error"
              });
              this.facebookLoginLoading = false;
            }
          }
        });
      }
    },
    goToRequestPassword() {
      this.$router.push({ name: "reset-password-request" });
    },
    goToRegister() {
      this.$store.commit("config/resetRegistrationChoice");
      this.$router.push({ name: "registration" });
    },
    login(e) {
      e.preventDefault();
      if (!this.$refs.loginform.validate()) {
        return;
      }
      this.loading = true;

      this.$store
        .dispatch("user/login", {
          username: this.email,
          password: this.password
        })
        .then(() => {
          CookieHelper.setCookie("user", "authorized", 1);
          localStorage.setItem("authorized", "true");
          // https://stackoverflow.com/questions/62223195/vue-router-uncaught-in-promise-error-redirected-from-login-to-via-a
          this.$router
            .push({ name: this.$store.state.config.main_page })
            .catch(() => {});
        })
        .catch(error => {
          switch (error.response.data.message) {
            case "Invalid credentials.":
              this.$store.commit("viewstate/notify", {
                color: "error",
                text: this.$t("error.invalid_credentials")
              });
              break;
            case "Account disabled.":
              this.$store.commit("viewstate/notify", {
                color: "error",
                text: this.$t("error.account_disabled")
              });
              break;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
